/* eslint-disable no-unused-vars */
import ReactDOM from 'react-dom';
import App from './App';

import './index.css';
import { patchMapLibraryDrawingManager } from './shared/googleMaps/drawingManagerShim';

declare global {
  interface Window {
    fcWidget: any;
    Cypress: any;
    saveAsPNG: () => Promise<void>;
  }
}

// Precisa rodar antes de qualquer <Maps /> montar. Ver o comentário do módulo.
patchMapLibraryDrawingManager();

window.addEventListener('resize', () => {
  const widthScreen = document.body.clientWidth;
  sessionStorage.setItem(
    'modeScreen',
    widthScreen >= 920 ? 'desktop' : 'mobile'
  );
});

ReactDOM.render(<App />, document.getElementById('root'));
